(function (app) {
    app.provider("figAccountDataApi", [function () {
        this.$get = ["externalsApiGateway", function(externalsApiGateway) {
            var service = {};

            service.getFigDataPolicyId = function(insuranceAccountId) {
                return externalsApiGateway.get("/Accounts/External/Fig/" + insuranceAccountId + "/FigDataExists");
            };

            service.getFigData = function(externalAccountId) {
                return externalsApiGateway.get("/Accounts/External/Fig/" + externalAccountId + "/GetFigData");
            };

            service.getAcmDataPolicyId = function(investmentAccountId) {
                return externalsApiGateway.get("/Accounts/External/Acm/" + investmentAccountId + "/FigDataExists");
            };

            service.getAcmData = function(externalAccountId) {
                return externalsApiGateway.get("/Accounts/External/Acm/" + externalAccountId + "/GetFigData");
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line